import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/jarl/Documents/Projects/civitas/kenobi/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
import Colors from '../components/Colors';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "colors"
    }}>{`Colors`}</h1>

    <Colors mdxType="Colors" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      